import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import BottomDrawer from "components/WMS/Mobile/BottomDrawer";
import RightDrawerDesktop from "components/WMS/Desktop/RightDrawerDesktop";

import {WMSContext} from "../../../../../../../context/WMSContext";

DrawerSelector.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
};

function DrawerSelector({open, handleClose, ...props}) {
    const {isMobile} = useContext(WMSContext)

    if (isMobile) {
        return (
            <BottomDrawer
                open={open}
                onClose={handleClose}
                openMaxHeight
                noHeightLimit
                disablePortal
                title={<FormattedMessage id='wms.packing.productProblem.title' />}
                subtitle={<FormattedMessage id='wms.packing.productProblem.subtitle' />}
            >
                {props.children}
            </BottomDrawer>
        )
    } else {
        return (
            <RightDrawerDesktop
                open={open}
                onClose={handleClose}
                withoutHeadBorder={true}
                title={<FormattedMessage id='wms.packing.productProblem.title' />}
                subtitle={<FormattedMessage id='wms.packing.productProblem.subtitle' />}
            >
                {props.children}
            </RightDrawerDesktop>
        );
    }
}

export default DrawerSelector;
